// src/components/Header.jsx
import React from "react";
import "./Header.css";

function Header() {
  return (
    <header className="hero-section">
      <div className="container">
        <div className="hero-content">
          <div className="hero-text">
            <p className="hero-subtitle">Korepetycje z Matematyki</p>
            <h1>Cześć, jestem Agnieszka</h1>
            <p className="hero-description">
              Jestem doświadczoną nauczycielką i pasjonatką matematyki. Uczę dzieci i młodzież już od 30 lat. Oferuję indywidualne zajęcia matematyki.
            </p>
            <div className="hero-stats">
  <div className="stat">
    <strong>30+</strong>
    <span>Lat doświadczenia</span>
  </div>
  <div className="stat">
    <strong>250+</strong>
    <span>Zadowolonych uczniów</span>
  </div>
  <div className="stat">
    <strong>6000+</strong>
    <span>Godzin lekcyjnych</span>
  </div>
</div>
          </div>
          <div className="hero-image">
            <img src="/images/mama-zdjecie.jpg" alt="Zdjęcie1" />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;